(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enveenine-v3-card-filter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('envee-product-filter')) {
    customElements.define('envee-product-filter', class extends HTMLElement {
      connectedCallback() {
        this.facetBreakpoint ??= window.matchMedia('(min-width: 1000px)');
        this.syncFacetLayout ??= () => this.querySelector('.envee-v3-filter__facets')?.toggleAttribute('open', this.facetBreakpoint.matches);
        this.facetBreakpoint.addEventListener('change', this.syncFacetLayout);
        this.syncFacetLayout();
        if (this.hasAttribute('data-ready')) return;

        this.setAttribute('data-ready', '');
        this.items = Array.from(this.querySelectorAll('[data-filter-product]'));
        this.grid = this.querySelector('[data-filter-grid]');
        this.search = this.querySelector('[data-filter-search]');
        this.sort = this.querySelector('[data-filter-sort]');
        this.count = this.querySelector('[data-filter-count]');
        this.empty = this.querySelector('[data-filter-empty]');
        this.chips = Array.from(this.querySelectorAll('[data-filter-chip]'));

        this.chips.forEach((chip) => chip.addEventListener('click', () => {
          chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          this.applyFilters();
        }));

        this.querySelectorAll('[data-filter-reset]').forEach((button) => button.addEventListener('click', () => this.resetFilters()));
        this.search?.addEventListener('input', () => this.applyFilters());
        this.sort?.addEventListener('change', () => this.applyFilters());
        this.applyFilters();
      }

      disconnectedCallback() {
        this.facetBreakpoint?.removeEventListener('change', this.syncFacetLayout);
      }

      resetFilters() {
        this.chips.forEach((chip) => chip.setAttribute('aria-pressed', 'false'));
        if (this.search) this.search.value = '';
        if (this.sort) this.sort.value = 'featured';
        this.applyFilters();
      }

      applyFilters() {
        const query = this.search?.value.trim().toLowerCase() || '';
        const groups = new Map();

        this.chips.filter((chip) => chip.getAttribute('aria-pressed') === 'true').forEach((chip) => {
          const values = groups.get(chip.dataset.group) || [];
          values.push(chip.dataset.value);
          groups.set(chip.dataset.group, values);
        });

        let visibleCount = 0;

        this.items.forEach((item) => {
          const searchable = item.dataset.search || '';
          let tags = [];

          try {
            tags = JSON.parse(item.dataset.tags || '[]').map((tag) => tag.toLowerCase());
          } catch (error) {
            tags = [];
          }

          const matchesSearch = query === '' || searchable.includes(query);
          const matchesGroups = Array.from(groups.entries()).every(([group, values]) => {
            if (group === 'condition') {
              const conditions = (item.dataset.conditions || '').split('|').filter(Boolean);
              return values.some((value) => conditions.includes(value));
            }

            return values.some((value) => tags.includes(value) || searchable.includes(value));
          });
          const matches = matchesSearch && matchesGroups;

          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        const direction = this.sort?.value || 'featured';
        const sortedItems = [...this.items].sort((first, second) => {
          if (direction === 'price-ascending') return Number(first.dataset.price) - Number(second.dataset.price);
          if (direction === 'price-descending') return Number(second.dataset.price) - Number(first.dataset.price);
          if (direction === 'title-ascending') return first.dataset.title.localeCompare(second.dataset.title);
          return Number(first.dataset.index) - Number(second.dataset.index);
        });

        sortedItems.forEach((item) => this.grid?.append(item));

        if (this.count) {
          const resultsLabel = visibleCount === 1 ? this.dataset.resultsLabel.replace(/\bproducten\b/i, 'product') : this.dataset.resultsLabel;
          this.count.textContent = `${visibleCount} ${resultsLabel}`;
        }
        if (this.empty) this.empty.hidden = visibleCount !== 0;
        if (this.grid) this.grid.hidden = visibleCount === 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enveenine-v3-quote-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('envee-quote-slider')) {
    customElements.define('envee-quote-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-envee-quote-track]');
        this.slides = [...this.querySelectorAll('[data-envee-quote-slide]')];
        this.dots = [...this.querySelectorAll('[data-envee-quote-dot]')];
        this.previousButton = this.querySelector('[data-envee-quote-previous]');
        this.nextButton = this.querySelector('[data-envee-quote-next]');
        this.activeIndex = 0;
        this.maxIndex = 0;
        this.scrollFrame = null;
        this.autoplayTimer = null;
        this.abortController = new AbortController();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.track || this.slides.length === 0) return;

        const signal = this.abortController.signal;
        this.previousButton?.addEventListener('click', () => this.move(-1, true), { signal });
        this.nextButton?.addEventListener('click', () => this.move(1, true), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true), { signal }));
        this.track.addEventListener('scroll', () => this.handleScroll(), { passive: true, signal });
        this.addEventListener('mouseenter', () => this.stopAutoplay(), { signal });
        this.addEventListener('mouseleave', () => this.startAutoplay(), { signal });
        this.addEventListener('focusin', () => this.stopAutoplay(), { signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.startAutoplay();
        }, { signal });
        this.track.addEventListener('pointerdown', () => this.stopAutoplay(), { signal });
        this.track.addEventListener('pointerup', () => this.startAutoplay(), { signal });
        this.track.addEventListener('pointercancel', () => this.startAutoplay(), { signal });
        document.addEventListener('visibilitychange', () => document.hidden ? this.stopAutoplay() : this.startAutoplay(), { signal });
        document.addEventListener('shopify:block:select', event => this.handleBlockSelect(event), { signal });
        document.addEventListener('shopify:block:deselect', () => this.startAutoplay(), { signal });
        this.resizeObserver = new ResizeObserver(() => this.refreshLayout());
        this.resizeObserver.observe(this.track);

        this.refreshLayout();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      get autoplayEnabled() {
        return this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reducedMotion.matches && !Shopify.designMode;
      }

      get autoplaySpeed() {
        return Math.max(3000, Number(this.dataset.autoplaySpeed) || 5000);
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.autoplayEnabled || document.hidden) return;
        this.autoplayTimer = window.setTimeout(() => {
          this.move(1, false);
          this.startAutoplay();
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      move(direction, manual) {
        const slideCount = this.maxIndex + 1;
        const nextIndex = (this.activeIndex + direction + slideCount) % slideCount;
        this.goTo(nextIndex, manual);
      }

      goTo(index, manual, instant = false) {
        const nextIndex = Math.max(0, Math.min(index, this.maxIndex));
        const slide = this.slides[nextIndex];
        if (!slide) return;
        this.activeIndex = nextIndex;
        this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: instant || this.reducedMotion.matches ? 'auto' : 'smooth' });
        this.updateNavigation();
        if (manual) this.startAutoplay();
      }

      refreshLayout() {
        const firstSlide = this.slides[0];
        if (!firstSlide) return;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap) || 0;
        const visibleSlides = Math.max(1, Math.floor((this.track.clientWidth + gap) / (firstSlide.offsetWidth + gap)));
        this.maxIndex = Math.max(0, this.slides.length - visibleSlides);
        this.activeIndex = Math.min(this.activeIndex, this.maxIndex);
        this.goTo(this.activeIndex, false, true);
        this.updateNavigation();
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const target = this.track.scrollLeft;
          let nearestIndex = 0;
          let nearestDistance = Infinity;

          this.slides.slice(0, this.maxIndex + 1).forEach((slide, index) => {
            const distance = Math.abs((slide.offsetLeft - this.slides[0].offsetLeft) - target);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          if (nearestIndex !== this.activeIndex) {
            this.activeIndex = nearestIndex;
            this.updateNavigation();
          }
        });
      }

      updateNavigation() {
        this.dots.forEach((dot, index) => {
          const unavailable = index > this.maxIndex;
          dot.hidden = unavailable;
          dot.disabled = unavailable;
          dot.setAttribute('aria-current', index === this.activeIndex ? 'true' : 'false');
        });
      }

      handleBlockSelect(event) {
        const slide = event.target.closest?.('[data-envee-quote-slide]');
        if (!slide || !this.contains(slide)) return;
        this.stopAutoplay();
        this.goTo(this.slides.indexOf(slide), false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
